module.exports = __webpack_public_path__ + "img/alisha.8742ccb6.png";